import { Checkbox } from '@mui/material';
import { muiStyles } from 'utils/design';
import React from 'react';
import { useFormikContext } from 'formik';
import { OfficialForm } from 'store/officials/officials.types';

const useStyles = muiStyles(() => ({
  root: {
    padding: '1px',
    color: '#333',
  },
}));

interface UnitsCheckboxCellProps {
  data: {
    id: string;
    isInstitution: boolean;
  };
}

export const UnitsCheckboxCell: React.FC<UnitsCheckboxCellProps> = ({ data }) => {
  const classes = useStyles();
  const { values, setFieldValue } = useFormikContext<OfficialForm>();

  if (!data || data.isInstitution) {
    return null;
  }

  const id = String(data.id);
  const current = new Set((values.units || []).map(String));
  const checked = current.has(id);

  const toggle = () => {
    const next = new Set((values.units || []).map(String));
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    setFieldValue('units', Array.from(next));
  };

  return (
    <Checkbox
      color="primary"
      classes={classes}
      checked={checked}
      onChange={toggle}
      disableRipple
    />
  );
};
